import { gql } from "graphql-request"
import { ServiceGraphql } from "./Graphql"

export const graphGenOtp = async () => {
  const GEN_OTP = gql`
  mutation GenerateOtp {
    GenerateOtp
  }
  `
  const response = await ServiceGraphql.request(GEN_OTP);
  return response.GenerateOtp

}